import React from 'react';
import ReactDOM from 'react-dom';

import {
    Timeline,
    timelineEncode,
    timelineDecode,
    timelineHasErrors,
    timelineGetErrors
} from '../itinerary/Timeline.jsx';

class ReactTimeline {
    constructor(element) {
        this.element = element;
        this.l10n = null;
        this.timeline = null;
        // this.useDateTime = null;
        this.viewOnly = null;
    }

    render({
        l10n,
        timeline,
        // useDateTime,
        viewOnly
    }) {
        this.l10n = l10n;
        this.timeline = timeline;
        // this.useDateTime = useDateTime;
        this.viewOnly = viewOnly;
        this._render();
    }

    _render() {
        ReactDOM.render(
            <Timeline
                l10n={this.l10n}
                timeline={this.timeline}
                // useDateTime={this.useDateTime}
                viewOnly={this.viewOnly}
                onChange={timeline => {
                    this.timeline = timeline;
                    this._render();
                }}
            />,
            this.element
        );
    }

    unrender() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    static encode(timeline) {
        return timelineEncode(timeline);
    }

    static decode(json) {
        return timelineDecode(json);
    }

    static hasErrors(timeline) {
        return timelineHasErrors(timeline);
    }

    static getErrors(timeline) {
        return timelineGetErrors(timeline);
    }
}

global.ReactTimeline = ReactTimeline;
